<template>
  <section class="finances__widget">
    <article class="finances__widget-body">
      <h3 class="finances__widget-title">
        Últimas transações

        <i v-if="loading" class="icon loading float-right" />
      </h3>

      <transition name="fade">
        <dl v-if="!loading && transactions.length > 0" class="finances__statement">
          <template v-for="(transaction, index) in transactions">
            <dt
              class="finances__statement-tit"
              :class="(index + 1  === transactions.length) && 'last'"
              :key="transaction.id + 'label'"
            >
              {{ transaction.description }}
              em
              {{ $moment(transaction.date).format('DD/MM/YYYY') }}
            </dt>
            <dd
              class="finances__statement-val"
              :class="
                (index + 1 === transactions.length ? 'last' : '') +
                (transaction.type === 'RECEITA'
                  ? ' finances__statement-val--income'
                  : ' finances__statement-val--outcome')
              "
              :key="transaction.id + 'value'"
            >
              R$ {{ transaction.value | TO_BRL }}
            </dd>
          </template>
        </dl>

        <dl v-if="!loading && transactions.length === 0" class="finances__statement">
          <dt class="finances__statement-tit">
            Nenhuma transação encontrada.
          </dt>
          <dd class="finances__statement-val">&nbsp;</dd>
        </dl>
      </transition>
    </article>

    <footer class="finances__widget-footer">
      <router-link
        :to="`/${fn_GET_PARENT_ROUTE($route)}/finances/list`"
        :disabled="!Array.isArray(financialCategories) || financialCategories.length === 0"
        tag="a"
        class="btn btn-primary"
      >
        Ver extrato
      </router-link>
    </footer>
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'lastTransactions',

  props: {
    financialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      loading: false,
      transactions: []
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },

  watch: {
    office: {
      deep: true,
      immediate: false,
      handler () {
        this.init()
      }
    }
  },

  created () {
    EventBus.$on('reload-finance', () => this.init())
    this.init()
  },

  methods: {
    init () {
      const finalDate = this.$moment().format('YYYY-MM-DD')
      const prefix = this.fn_GET_PARENT_ROUTE(this.$route)
      const url = `/${prefix}/doctor_office/${this.office.id}/financial_statement?filterAndLessThanOrEqual[fs.date]=${finalDate}&order[fs.date]=DESC&itensPerPage=5&filterNot[fs.status]=CANCELADO`

      this.transactions = []
      this.loading = true
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.transactions = res.data.data
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
